@border-radius: 15px;
@grid-column-gap: 50px;
@items-gap: 25px;

* {
  box-sizing: border-box;
}

h2,
h3 {
  margin: 0;
}
p {
  margin: 0;
}
img {
  width: 100%;
}
a {
  color: inherit;
  text-decoration: none;
}

.container {
  container-type: inline-size;
}

.socials {
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: contain;
  border: 1px solid white;
  border-radius: 50em;
  width: 30px;
  height: 30px;
}

@import 'igws-author-profile.page.less';
@import 'igws-author-profile.widget.less'; 
 